export default "__VITE_ASSET__EPoZhrQL__"